<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 17:03:03
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-03 18:26:55
 * @FilePath: \gcp-fe\src\app\shop\components\showDataPage.vue
 * @Description: 首页 数据展示区
-->

<template>
  <div class="head clearfix">
    <div class="content clearfix">
      <div class="showBox">
        <div
          v-for="(item, index) in dataOptions"
          :key="index"
          class="showBoxMain"
        >
          <div class="showBoxItem">
            <div class="imgBox">
              <img :src="item.imgSrc" alt="" />
            </div>
            <div class="textBox">
              <span>{{ item.title }}</span>
              <p>{{ Number(item.value).toLocaleString() }}</p>
              <span>{{ item.remark }}</span>
            </div>
          </div>
          <div class="lineBox" v-if="index !== dataOptions.length - 1">
            <el-divider direction="vertical"></el-divider>
          </div>
          <div class="lineBoxs" v-else></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { qryComprehensiveDataOverview } from "@/app/shop/api/shopping";

export default {
  data() {
    return {
      dataOptions: [
        {
          key: 1,
          imgSrc: require("@/basa/assets/images/show1.png"),
          title: this.$t("showDataPage.dataOptions.titleOne"), // 合作商数量(家)
          value: 0,
          remark: this.$t("showDataPage.dataOptions.remarkOne") // 汇聚优质合作商，招投标更高效
        },
        {
          key: 2,
          imgSrc: require("@/basa/assets/images/show2.png"),
          title: this.$t("showDataPage.dataOptions.titleTwo"), // 采购笔数
          value: 0,
          remark: this.$t("showDataPage.dataOptions.remarkTwo") // 采购项目丰富，机会无限
        },
        {
          key: 3,
          imgSrc: require("@/basa/assets/images/show3.png"),
          title: this.$t("showDataPage.dataOptions.titleThree"), // 中标通知
          value: 0,
          remark: this.$t("showDataPage.dataOptions.remarkThree") // 招采项目抢先看，提升中标率
        },
        {
          key: 4,
          imgSrc: require("@/basa/assets/images/show4.png"),
          title: this.$t("showDataPage.dataOptions.titleFour"), // 今日新增采购公告
          value: 0,
          remark: this.$t("showDataPage.dataOptions.remarkFour") // 海量采购公告，等你来竞标
        }
      ]
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await qryComprehensiveDataOverview({
        languageFlag: Cookies.get("language")
      });
      if (res.data.code === "0") {
        // 合作商数量
        this.dataOptions[0].value = res.data.data.partnersNum;
        // 采购笔数
        this.dataOptions[1].value = res.data.data.purchaseNum;
        // 中标通知
        this.dataOptions[2].value = res.data.data.bidResultNum;
        // 今日新增采购公告
        this.dataOptions[3].value = res.data.data.todayAddPurchaseNum;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.showBox {
  margin-top: 10px;
  margin-left: 20px;
  padding: 20px 0;
  display: flex;
  justify-content: space-around;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #666666;
  line-height: 14px;
  text-align: left;
  font-style: normal;

  .showBoxMain {
    width: 25%;
    display: flex;
    justify-content: space-evenly;

    .showBoxItem {
      display: flex;

      p {
        font-weight: 600;
        font-size: 22px;
        color: #333333;
        line-height: 30px;
      }

      .textBox {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
      }
    }

    .lineBox /deep/ .el-divider--vertical {
      height: 40px;
      margin-top: 15px;
      margin-left: 60px;
    }
    .lineBoxs {
      width: 1px;
      height: 40px;
      margin-top: 15px;
      margin-left: 60px;
    }
  }
}
</style>
